import { Component } from 'react'
import {findDOMNode} from 'react-dom'

export class NavigationSearch extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  showSearch = (event) => {
    document.querySelector('header').classList.add('search-is-open')
    this.setState({ isOpen: true })
  }

  submitSearch = (event) => {
    findDOMNode(this).submit()
  }

  render() {
    if (this.state.isOpen) {
      return <form action={ this.props.searchUrl } method='POST'>
        <input
          className='form-control'
          autoFocus
          name='query'
          placeholder={ I18n.t('layouts.header.search_placeholder') } />

        <i className="fa fa-search header-search-icon" onClick={ this.submitSearch }></i>
      </form>
    } else {
      return <i className="header-search-icon fa fa-search" onClick={ this.showSearch }></i>
    }
  }
}
